<template>
  <div v-if="isVisible" class="modal-backdrop">
    <div class="modal-content">
      <h3 class="text-lg font-bold mb-4">{{ $t('athletes.modalOrder.title') }}</h3>

      <div class="flex justify-start mb-4 gap-x-4">
      <button @click="shuffleAthletes" class="btn btn-primary flex items-center">
          <i class="fas fa-random mr-2"></i> {{ $t('athletes.modalOrder.shuffle') }}
        </button>
        <button @click="toggleManualEdit" class="btn btn-secondary flex items-center mx-2">
          <i class="fas fa-arrows-alt mr-2"></i> {{ manualEdit ? $t('athletes.modalOrder.cancelEdit') : $t('athletes.modalOrder.manual') }}
        </button>
      </div>

      <table class="table-auto w-full border text-left">
        <tbody>
        <tr
            v-for="(athlete, index) in localAthletes"
            :key="athlete.id"
            :class="['athlete-row', manualEdit ? 'drag-enabled' : '']"
            :draggable="manualEdit"
            @dragstart="startDrag(index)"
            @dragover.prevent
            @drop="onDrop(index)"
            @dragend="endDrag"
        >
          <td class="border px-2 text-center order-cell" style="width: 120px; max-width: 120px;">
            <div class="order-cell-content">
              <span v-if="manualEdit" class="drag-handle" aria-hidden="true">
                <i class="fas fa-grip-vertical"></i>
              </span>
              <span class="order-number">{{ athlete.order_number !== null ? athlete.order_number : '-' }}</span>
            </div>
          </td>
          <td class="border px-2 text-center">
            <img :src="athlete.user.img_path" class="athlete-img" />
          </td>
          <td class="border px-2">{{ athlete.user.name }}</td>
          <td class="border px-2">{{ athlete.user.surname }}</td>
        </tr>
        </tbody>
      </table>

      <div class="modal-buttons mt-4 gap-4">
        <button v-if="hasChanged" @click="saveOrder" class="btn btn-save">
          <i class="fas fa-save"></i> {{ $t('athletes.modalOrder.save') }}
        </button>
        <button @click="$emit('closeModal')" class="btn btn-cancel">
          {{ $t('athletes.modalOrder.close') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderAthletesTableModal',
  props: {
    isVisible: Boolean,
    athletes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localAthletes: [],
      hasChanged: false,
      manualEdit: false,
      dragIndex: null,
    };
  },
  watch: {
    isVisible(val) {
      if (val && Array.isArray(this.athletes)) {
        const orderedAthletes = [...this.athletes]
            .map(a => ({
              ...a,
              order_number: a.order_number !== null ? Number(a.order_number) : null
            }))
            .sort((a, b) => {
              const aOrder = a.order_number ?? Infinity;
              const bOrder = b.order_number ?? Infinity;
              return aOrder - bOrder;
            });
        this.localAthletes = this.normalizeOrder(orderedAthletes);
        this.hasChanged = false;
        this.manualEdit = false;
        this.dragIndex = null;
      }
    }
  },
  methods: {
    normalizeOrder(list) {
      return list.map((athlete, index) => ({
        ...athlete,
        order_number: index + 1
      }));
    },
    shuffleAthletes() {
      this.localAthletes = this.normalizeOrder([...this.localAthletes].sort(() => Math.random() - 0.5));
      this.hasChanged = true;
    },
    toggleManualEdit() {
      this.manualEdit = !this.manualEdit;
      this.dragIndex = null;
    },
    startDrag(index) {
      this.dragIndex = index;
    },
    onDrop(index) {
      if (this.dragIndex === null || this.dragIndex === index) {
        this.dragIndex = null;
        return;
      }
      const updated = [...this.localAthletes];
      const [moved] = updated.splice(this.dragIndex, 1);
      updated.splice(index, 0, moved);
      this.localAthletes = this.normalizeOrder(updated);
      this.hasChanged = true;
      this.dragIndex = null;
    },
    endDrag() {
      this.dragIndex = null;
    },
    saveOrder() {
      this.localAthletes = this.normalizeOrder(this.localAthletes);
      this.hasChanged = false;
      this.manualEdit = false;
      this.$emit("orderAthletes", this.localAthletes);

    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 50;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
}
.table-auto th,
.table-auto td {
  border: 1px solid #ccc;
  padding: 8px;
}
.order-cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.drag-handle {
  color: #6c757d;
  cursor: grab;
}
.athlete-row.drag-enabled {
  cursor: grab;
}
.athlete-row.drag-enabled:active {
  cursor: grabbing;
}
.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
}
.btn {
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.btn-primary {
  background: #28a745;
  color: white;
}
.btn-secondary {
  background: #6c757d;
  color: white;
}
.btn-save {
  background: #28a745;
  color: white;
}
.btn-cancel {
  background: #ccc;
  color: black;
}
.athlete-img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #ddd;
  object-fit: cover;
}
</style>